import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { getDataScopeByPermission } from 'src/app/core/utils/common-functions';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { SessionServiceService } from 'src/app/core/services/session-service.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'laas-permission-button',
  templateUrl: './permission-button.component.html',
  styleUrls: ['./permission-button.component.scss']
})
export class PermissionButtonComponent implements OnInit {
  @Input() permissionCode: PermissionConstants = '';
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() class: string = '';
  @Input() style: string = '';
  @Input() icon: string = '';
  @Input() type: string = '';
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  isButtonAuth: boolean = false;

  constructor(
    private sessionService: SessionServiceService
  ) {}

  onButtonClick(event: any): void {
    if (!this.isButtonAuth) {
      return;
    }
    this.onClick.emit(event);
  }

  async ngOnInit(): Promise<void> {
    combineLatest([
      this.sessionService.getPermissionCodes(),
      this.sessionService.getUserProfile(),
    ]).subscribe(async ([permissionCodes, userProfile]) => {
      if (!permissionCodes.length || !userProfile) {
        return;
      }
      const scope = await getDataScopeByPermission(userProfile, this.permissionCode);
      this.isButtonAuth = !!scope.length;
      if (!this.permissionCode) {
        this.isButtonAuth = true;
      }
      if (userProfile.userType == UserType.SuperAdmin) {
        this.isButtonAuth = true;
      }
    });
  }
}
